import Alpine from 'alpinejs';
export default {
    data: {
        summary_count: 0
    },

    init() {
        this.data = { ...this.getData() };

        Alpine.store('global').onAjaxComplete(
            () => (this.data = { ...this.getData() })
        );
    },

    getData() {
        return Alpine.store('global').storage.get('cart');
    }
};
